import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DataSource } from '@angular/cdk/collections';
import { FormControl, Validators } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { OnlinekeyCardModel } from './onlinekeys-search.model';
import { OnlineKeySearchResponseModel, PaginationModel } from '../../../screens/models/Onlinekeys-search.model';
import { DetailScreensService } from '../../../services/detail-screens-service';
import { UiHelperService } from '../../../../../../services/shared/helpers/ui-helper.service';
import { DetailScreenComponent } from '../../../detail-screen/detail-screen.component';


import {ONLINE_KEY} from './onlinekey-search.constants';
import {OnlineKeyService} from '../onlinekey.service';

@Component({
  selector: 'app-detail-table',
  templateUrl: './onlinekey-search.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class OnlineKeySearchComponent {
  public restrictedData: boolean;
  public tableColumns: string[];
  public tableData: OnlinekeyCardModel[];
  public errorText: string;
  public showTable: boolean;
  public dataSource = new MatTableDataSource<OnlinekeyCardModel>([]);
  public detailScreenComponent: DetailScreenComponent;
  public paginationObj: PaginationModel;
  public FORM_INFO = ONLINE_KEY;
  emptyValuePlaceholder = '-';
  private isFirstResult = true;
  private searchData = {
    selectedPage: 1,
    searchValue: null,
    relationRestrictedDataView: false,
    restrictedDataViewException: false,
  };
  public localPaginationObj = {
    selectedPage: 1,
    resultsPerPage: 10,
    totalNumberOfCards: null,
  };
  public errors = {
    isEmptyResult: false,
  };

  pageEvent: PageEvent;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  queryFormControl = new FormControl('', [
      Validators.required,
    ],
  );

  constructor(public onlineKeyService: OnlineKeyService,
              public detailScreensService: DetailScreensService,
              public uiHelperService: UiHelperService) {
    this.tableColumns = [];
    this.tableData = [];
  }

  public ngOnInit(): void {}

  public ngAfterViewInit(): void {}

  public search() {
    if (!this.queryFormControl.valid &&
      (this.paginationObj.totalNumberOfCards === 0)) {
      return;
    }
    this.errorText = '';

    this.searchData.searchValue = this.queryFormControl.value;

    this.onlineKeyService.searchOnlineKeys(this.searchData)
      .pipe(catchError((res) => res))
      .subscribe((res: OnlineKeySearchResponseModel) => {
        if ((res.searchResult && !res.searchResult.cards) || (res.searchResult && !res.searchResult.cards.length)) {
          this.errors.isEmptyResult = true;
          this.dataSource.data = [];
          this.showTable = false;
          this.errorText = ONLINE_KEY.SEARCH_INPUT_NO_ITEMS_FOUND_ERROR;
        } else {
          this.showTable = true;
          this.errors.isEmptyResult = false;
          this.dataSource.data = res.searchResult.cards;
          this.localPaginationObj.resultsPerPage = res.paginationObject.resultsPerPage;
          this.localPaginationObj.totalNumberOfCards = res.paginationObject.totalNumberOfCards;
          this.localPaginationObj.selectedPage = res.paginationObject.selectedPage;
        }
        this.detailScreenComponent.changeRef.detectChanges();
      });
  }

  public clearInput() {
    this.queryFormControl.setValue('');
    this.searchData.selectedPage = 1;
    this.search();
  }

  public paginate(event: PageEvent) {
    this.prepareSearchPaginationData(event.pageIndex + 1);
    this.search();
    return event;
  }

  private prepareSearchPaginationData(page?: number) {
    this.searchData = {
      selectedPage: page || 1,
      searchValue: this.queryFormControl.value,
      relationRestrictedDataView: false,
      restrictedDataViewException: false,
    };
  }
  public navigateToOnlineKeyDetail(data: OnlinekeyCardModel) {
    this.uiHelperService.addBusyCursor();
    this.detailScreensService.getDetailsPage(
      'onlinekeyarrangement',
      data.cardArrangementNumber,
      data.administrationCode,
      '',
      data.bankCode,
      '',
      false)
      .pipe(catchError((res) => res))
      .subscribe((response) => {
        if (this.isFirstResult) {
          this.createResultPanel(response);
        } else {
          this.setSearchResultData();
        }

        this.uiHelperService.removeBusyCursor();
      });
  }

  private createResultPanel(response) {
    this.detailScreenComponent.secondScreenInstance.createScreen(response, 'onlinekeyarrangement', null);
  }

  private setSearchResultData() {
    this.detailScreenComponent.changeRef.detectChanges();
  }

}
